'use memo';

import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client';
import QldAgreementDetails from './QldAgreementDetails';
import NswAgreementDetails from './NswAgreementDetails';
import { TaskModalPageProps } from 'pages/allTasks/TaskModal/TaskModalPageProps';

const AgreementDetails = (props: TaskModalPageProps) => {
  const { campaign } = props;

  switch (campaign.state) {
    case CampaignDetailModelState.QLD:
      return <QldAgreementDetails {...props} />;
    case CampaignDetailModelState.NSW:
      return <NswAgreementDetails {...props} />;
    default:
      return null;
  }
};

export default AgreementDetails;
